<template>
  <div class="d-inline-flex">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      bottom
      :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : '400px'"
    >
      <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-btn
              v-bind="{ ...menuAttrs, ...tooltipAttrs }"
              v-on="{ ...menuOn, ...tooltipOn }"
              icon
              small
              :disabled="disabled"
              @click="loadNotifications"
            >
              <v-badge
                v-if="notificationCount > 0"
                :content="notificationCount"
                color="orange"
                overlap
                small
              >
                <v-icon :color="color" small>mdi-email-multiple-outline</v-icon>
              </v-badge>
              <v-icon v-else :color="color" small>mdi-email-multiple-outline</v-icon>
            </v-btn>
          </template>
          <span>Histórico de Notificações</span>
        </v-tooltip>
      </template>

      <v-card min-width="300">
        <v-card-title class="ma-0 pa-0">
          <v-app-bar dense class="grey lighten-5 mb-0 elevation-1">
            <v-toolbar-title class="subtitle-1">
              Histórico de Notificações
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small class="mr-1" @click.native="menu = false" v-bind="attrs" v-on="on">
                  <v-icon color="red lighten-2">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Fechar</span>
            </v-tooltip>
          </v-app-bar>
        </v-card-title>
        
        <v-card-text class="pa-0">
          <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
          
          <v-list v-if="!loading && notifications.length > 0" dense class="py-0">
            <v-list-item 
              v-for="(notification, index) in notifications" 
              :key="notification.id || index"
              class="px-4"
            >
              <v-list-item-icon class="mr-3">
                <v-icon small color="primary">mdi-email-send-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="caption">
                  {{ formatDate(notification.sent_at) }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="notification.user" class="caption grey--text">
                  Por: {{ notification.user.name }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-alert 
            v-if="!loading && loadError" 
            type="error" 
            text 
            dense 
            class="ma-3"
          >
            Não foi possível carregar o histórico.
          </v-alert>

          <v-alert 
            v-if="!loading && !loadError && notifications.length === 0" 
            type="info" 
            text 
            dense 
            class="ma-3"
          >
            Nenhuma notificação enviada ainda.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SysTermNotificationHistory',
  
  data: () => ({
    menu: false,
    loading: false,
    notifications: [],
    loadError: false,
  }),

  props: {
    signatureId: {
      type: [Number, String],
      required: true,
    },
    notificationCount: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'grey',
    },
  },

  methods: {
    ...mapActions('term', ['ActionGetTermSignatureNotifications']),

    async loadNotifications() {
      if (this.loading) return
      
      this.loading = true
      this.notifications = []
      this.loadError = false

      try {
        const response = await this.ActionGetTermSignatureNotifications({
          id: this.signatureId,
        })
        this.notifications = response.data || []
      } catch (error) {
        this.notifications = []
        this.loadError = true
      } finally {
        this.loading = false
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      
      const date = new Date(dateString)
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
}
</script>
